import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldEmailComponent } from './field-email.component';
import { CardComponent } from '../../../@theme/components/card/card.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';



@NgModule({
  declarations: [
    FieldEmailComponent,
  ],
  exports: [
    FieldEmailComponent
  ],
  imports: [
    CommonModule,
    CardComponent,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule
  ]
})
export class FieldEmailModule { }
